import '@css/app.css';

import { createApp } from 'vue';
import Configurator from '@js/Components/Configurator.vue';

import { scrollToElementById } from "./helpers";

import {
    MapPinIcon,
    GlobeAltIcon,
    ChevronDownIcon,
} from '@heroicons/vue/24/outline';


$ = jQuery;

function refreshWooCommerceSelectEvents() {
    $("#variation_price")[0].dispatchEvent(new Event("input"));
    $("#variation_metal")[0].dispatchEvent(new Event("input"));
    $("#variation_size")[0].dispatchEvent(new Event("input"));
}

/**
 * When variations selects change
 */
$(document).on('show_variation', function () {
    const selectedOption = $('.summary').find('.variations select option:selected').val();

    if (selectedOption === '') {
        $('#variation_price').val(0);
        $('#variation_metal').val('');
        $('#variation_size').val('');
    } else {
        $('#variation_price').val(parseFloat($('.woocommerce-variation-price-raw').html()));
        $('#variation_metal').val($('#pa_metal option:selected').text());
        $('#variation_size').val($('#pa_size option:selected').text());
    }

    refreshWooCommerceSelectEvents();
});

/**
 * Toggle tabs
 */
$(document).on('click', '[data-tab-target-alt]', function (e) {
    e.preventDefault();

    const elem = $(this);
    const targetName = elem.attr('data-tab-target-alt');
    const target = $(`[data-tab-alt="${targetName}"]`);

    if (!target.length) {
        return;
    }

    elem.parents('li').siblings().removeClass('active');
    elem.parents('li').addClass('active');

    target.siblings().slideUp(250);

    setTimeout(() => {
        target.slideDown(250);
    }, 250);
});


$(document).on('click', 'a[href="#product-configurator"]', function (e) {
    scrollToElementById('product-configurator');
});

/**
 * Load Vue app
 */
createApp(Configurator)
    .component('MapPinIcon', MapPinIcon)
    .component('GlobeAltIcon', GlobeAltIcon)
    .component('ChevronDownIcon', ChevronDownIcon)
    .mount('#product-configurator');
